import React, {Component} from 'react';
import {Switch, Route,withRouter} from 'react-router-dom';

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import UserHomepage from './../../APP/ROUTES/UserHomepage';
import GuestHomepage from './../../APP/ROUTES/GuestHomepage';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class HomePage extends Component {

	constructor(props)
    {
        super(props);
        this.state = {
            USER: this.props.USER
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.USER !== prevProps.USER) {
            this.setState({USER: this.props.USER});
        }
    }

	render() { 
        if (this.state.USER) {
            return <UserHomepage />
        } else {
            return <GuestHomepage />
        }
	}

}

export default withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(HomePage))
